import React, { useEffect, useState } from 'react'
// import { createGlobalStyle } from 'styled-components/macro'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { Box, CssBaseline, Paper } from '@mui/material'
import { spacing } from '@mui/system'
// import { isWidthUp } from '@mui/material/withWidth'
// import { withWidth } from '@mui/material'
import Sidebar from '../components/Sidebar'
import Header from '../components/AppBar'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import Footer from '../components/Footer'
// import 'antd/dist/antd.css'

const drawerWidth = 258

// const GlobalStyle = createGlobalStyle`
//   html,
//   body,
//   #root {
//     height: 100%;
//   }

//   body {
//     background: ${(props) => props.theme.palette.background.default};
//   }

//   .MuiCardHeader-action .MuiIconButton-root {
//     padding: 4px;
//     width: 28px;
//     height: 28px;
//   }
// `

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`



const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up('md')} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`

const AppContent = styled('div')({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  maxWidth: "100%"
})

//const Paper = styled(MuiPaper)(spacing)

// const MainContent = styled(Paper)`
//   flex: 1;
//   background: ${(props) => props.theme.palette.background.default};

//   @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
//     flex: none;
//   }

//   .MuiPaper-root .MuiPaper-root {
//     box-shadow: none;
//   }
// `



function Dashboard({ children, routes, width }) {
  const usertype = localStorage.getItem('usertype')
  const [mobileOpen, setMobileOpen] = useState(false)

  const history = useNavigate()
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }


  const checkBusiness = () => {
    const isBusinessAvailable = JSON.parse(localStorage.getItem('isBusinessAvailable'))
    if (isBusinessAvailable === false) {
      history('/business/create')
    }
  }

  useEffect(() => {
    if (usertype === 'Owner') {
      // checkBusiness()
    }
  }, [])
  const theme = useTheme();
  const hidden = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <Root>
      <CssBaseline />
      {/* <GlobalStyle /> */}
      <Drawer>
        {/* <Hidden mdUp implementation="js"> */}
        {/* {hidden ? null : <Sidebar
          routes={routes}
          PaperProps={{ style: { width: drawerWidth } }}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
        />
        } */}
        {/* </Hidden> */}
        {/* <Hidden smDown implementation="css"> */}
        <Sidebar routes={routes} PaperProps={{ style: { width: drawerWidth } }} />
        {/* </Hidden> */}
      </Drawer>
      <AppContent>
        <Header onDrawerToggle={handleDrawerToggle} />
        {/* <MainContent p={isWidthUp('lg', width) ? 12 : 5}>{children}</MainContent> */}
        <Box sx={{ p: 3, pb: 25, flex: 1, background: theme.palette.background.gray }}>{children}</Box>
        <Footer />
      </AppContent>
      {/* <Settings /> */}
    </Root>
  )
}

// export default withWidth()(Dashboard)
export default Dashboard

